import script from "./caseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./caseDetail.vue?vue&type=script&setup=true&lang=js"

import "./caseDetail.vue?vue&type=style&index=0&id=69eb6a6a&lang=less&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69eb6a6a"]])

export default __exports__